/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {onMessage} from 'firebase/messaging'
import moment from 'moment'
import {useCallback, useEffect, useRef, useState} from 'react'
import {generateToken, messaging} from '../../../../app/pages/firebase/firebase'
import {fetchData, getTranslatedValue, toasterrormsg} from '../../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {Toaster, toast} from 'react-hot-toast'
import debounce from 'lodash/debounce'
import {Link} from 'react-router-dom'
import {Tr} from '../../../i18n/Tr'
import {useLang} from '../../../i18n/Metronici18n'

const HeaderNotificationsMenu = ({setTotalUnreadRecords}: any) => {
  const t = Tr()
  const lang = useLang()
  function formatDateTime(dateTime: any) {
    const now = moment()
    const inputDate = moment(dateTime)

    // Check if the date is today
    if (inputDate.isSame(now, 'day')) {
      const diffInSeconds = now.diff(inputDate, 'seconds')
      if (diffInSeconds < 60) return `${diffInSeconds} sec`

      const diffInMinutes = now.diff(inputDate, 'minutes')
      if (diffInMinutes < 60) return `${diffInMinutes} min`

      const diffInHours = now.diff(inputDate, 'hours')
      if (diffInHours < 24) return `${diffInHours} hrs`
    }

    // For dates older than yesterday
    return inputDate.format('DD MMM')
  }
  const categoryId = sessionStorage.getItem('categoryId')
  var tmp: any = sessionStorage.getItem('vendor')
  tmp = JSON.parse(tmp)
  useEffect(() => {
    const fetchToken = async () => {
      const fcmToken = await generateToken()
      if (fcmToken) {
        var param = {
          vendorId: String(tmp['vendorId']),
          token: fcmToken,
        }
        var response: any = await fetchData('public/saveFCMToken', param)
        if (response.status == '200') {
        } else {
          toasterrormsg(response.message)
        }
      }
    }

    fetchToken()

    onMessage(messaging, (payload: any) => {
      toast.success(`${payload.notification.title}: ${payload.notification.body}`, {
        duration: 6000,
        position: 'top-center',
      })
      fetchNotifications(offset)
    })
  }, [])

  const [viewNotificationList, setNotificationList] = useState([]) as any
  const [offset, setOffset] = useState(0)
  const limit = 10 // Number of records per fetch
  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true) // Tracks if there are more records to load
  const scrollContainerRef = useRef(null)
  const lastScrollTopRef = useRef(0) // Tracks the last scroll position
  const [totalRecords, setTotalRecords] = useState('0')

  // view notification
  const fetchNotifications = async (currentOffset: number) => {
    if (isLoading || !hasMore) return
    setIsLoading(true)
    const param = {
      vendorId: String(tmp['vendorId']),
      offset: currentOffset,
      limit: limit,
    }
    const response: any = await fetchData('public/viewNotification', param)
    if (response.status == '200') {
      const data = response.data[0]
      setTotalRecords(data['totalRecords'])
      setTotalUnreadRecords(data['unreadRecords'])
      if (data['notification'].length < limit) {
        setHasMore(false) // No more records to fetch
      }
      
      const newNotifications = data['notification'].map((item: any) => ({
        notificationId: item.notificationId,
        title: item.title,
        description: item.message,
        time: formatDateTime(item.created),
        actionType: item.actionType,
        actionTypeId: item.actionTypeId,
      }));

      // Avoid duplicates
      setNotificationList((prevList: any) => [
        ...prevList,
        ...data['notification'].filter(
          (newItem: any) =>
            !prevList.some(
              (existingItem: any) => existingItem.notificationId == newItem.notificationId // Check for duplicate by notificationId
            )
        ),
      ]);

      // Avoid duplicates
     

      // setNotificationList(data['notification'])
      
      setOffset((prevOffset) => prevOffset + limit)
    }
    setIsLoading(false)
  }

  const handleScroll = useCallback(
    debounce(() => {
      const scrollContainer = scrollContainerRef.current
      if (scrollContainer) {
        const {scrollTop, scrollHeight, clientHeight} = scrollContainer
        const lastScrollTop = lastScrollTopRef.current
        if (
          scrollTop > lastScrollTop &&
          !isLoading &&
          scrollTop + clientHeight >= scrollHeight - 100 // Load slightly earlier
        ) {
          fetchNotifications(offset)
        }
        lastScrollTopRef.current = scrollTop
      }
    }, 200), // Debounce interval
    [offset, isLoading]
  )

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current as any
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll)
      return () => scrollContainer.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  useEffect(() => {
    // Call the API immediately on component mount
    fetchNotifications(0)
  }, [])
  // useEffect(() => {
  //   // Call the API immediately on component mount
  //   fetchNotifications(0);
  //   // Set up an interval to call the API every 10 seconds
  //   const intervalId = setInterval(() => {
  //     fetchNotifications(0);
  //   }, 10000);

  //   // Clean up the interval when the component unmounts
  //   return () => clearInterval(intervalId);
  // }, []);

  return (
    <>
      <Toaster />
      {/* <ToastContainer /> */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-400px'
        data-kt-menu='true'
      >
        <div
          className='d-flex flex-column bgi-no-repeat rounded-top'
          style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/menu-header-bg.jpg')}')`}}
        >
          <h3 className='text-white fw-semibold px-9 mt-10 mb-6'>
            {totalRecords} {t('Notifications')}
          </h3>
        </div>

        <div className='tab-content'>
          <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
            <div className='scroll-y mh-325px my-5 px-8' ref={scrollContainerRef}>
              {viewNotificationList.map((alert: any, index: any) => {
                return (
                  <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light-primary`)}>
                          {' '}
                          <KTIcon iconName={`information-5`} className={`fs-2 text-primary`} />
                        </span>
                      </div>
                      <div className='mb-0 me-2'>
                        {categoryId == '1' ? (
                          <>
                            {alert.actionType == 'BOOKINGDETAIL' ? (
                              <Link
                                to='../viewhotelbookingdetails/'
                                state={{bookingId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'HOTEL' ? (
                              <Link
                                to='../hoteloverview/'
                                state={{hotelId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'PROFILE' ? (
                              <Link
                                to='/crafted/account/settings'
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : (
                              <div className='fs-6 text-gray-800 fw-bold'>
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </div>
                            )}
                          </>
                        ) : categoryId == '3' ? (
                          <>
                            {alert.actionType == 'CAFE' ? (
                              <Link
                                to='../restaurantoverview/'
                                state={{restaurantId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'PROFILE' ? (
                              <Link
                                to='/crafted/account/settings'
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : (
                              <div className='fs-6 text-gray-800 fw-bold'>{alert.title}</div>
                            )}
                          </>
                        ) : categoryId == '4' ? (
                          <>
                            {alert.actionType == 'BOOKINGDETAIL' ? (
                              <Link
                                to='../viewspacebookingdetails/'
                                state={{bookingId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'SPACERENTAL' ? (
                              <Link
                                to='../spacerentaloverview/'
                                state={{spacerentalId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'PROFILE' ? (
                              <Link
                                to='/crafted/account/settings'
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : (
                              <div className='fs-6 text-gray-800 fw-bold'>{alert.title}</div>
                            )}
                          </>
                        ) : categoryId == '5' ? (
                          <>
                            {alert.actionType == 'BOOKINGDETAIL' ? (
                              <Link
                                to='../viewtourbookingdetails/'
                                state={{bookingId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'TOURPACKAGE' ? (
                              <Link
                                to='../tourpackageoverview/'
                                state={{tourpackageId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'PROFILE' ? (
                              <Link
                                to='/crafted/account/settings'
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : (
                              <div className='fs-6 text-gray-800 fw-bold'>{alert.title}</div>
                            )}
                          </>
                        ) : categoryId == '7' ? (
                          <>
                            {alert.actionType == 'BOOKINGDETAIL' ? (
                              <Link
                                to='../viewcarbookingdetails/'
                                state={{bookingId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'CARRENTAL' ? (
                              <Link
                                to='../carrentaloverview/'
                                state={{carrentalId: alert.actionTypeId}}
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : alert.actionType == 'PROFILE' ? (
                              <Link
                                to='/crafted/account/settings'
                                className='fs-6 text-gray-800 fw-bold'
                              >
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </Link>
                            ) : (
                              <div className='fs-6 text-gray-800 fw-bold'>
                                {/* {alert.title} */}
                                {getTranslatedValue(lang, alert, '_title') || ''}
                              </div>
                            )}
                          </>
                        ) : (
                          ''
                        )}
                        <div className='text-gray-400 fs-7'>
                          {/* {alert.description} */}
                          {getTranslatedValue(lang, alert, '_message') || ''}
                        </div>
                      </div>
                    </div>
                    <span className='badge badge-light fs-8'>{formatDateTime(alert.created)}</span>
                  </div>
                )
              })}
              {isLoading && (
                <div className='text-center py-3' data-kt-indicator='on'>
                  <span className='indicator-progress text-primary'>
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </div>
              )}
              {!hasMore && (
                <div className='text-center text-muted fw-bold py-3'>
                  {t('No more notifications')}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {HeaderNotificationsMenu}
